import type { SearchFilters } from '../types/search';
import hash from './hash';
import { safeLocalStorage } from './safeStorage';

export const getRecentSearches = (userId?: string): SearchFilters[] => {
	if (!userId) return [];
	const searches = safeLocalStorage.getItem(`${hash(userId)}-searches`);
	try {
		return (searches && JSON.parse(searches)) || [];
	} catch {
		// Guards against corrupt JSON in storage, not storage access (safeLocalStorage never throws).
		return [];
	}
};

export const setRecentSearches = (userId: string, searches: SearchFilters[]): void => {
	safeLocalStorage.setItem(`${hash(userId)}-searches`, JSON.stringify(searches));
};
